<script setup>
defineProps({
  hint: "",
  label: "",
  name: "",
});
</script>

<template>
  <label :for="name">
    {{ label}}
    <span>
      {{ hint }}
    </span>
  </label>
</template>

